export var addEventForCypress = function (eventName, id) {
    if (id === void 0) { id = ''; }
    var detail = id ? { detail: { id: id } } : null;
    if (window.Cypress) {
        window.dispatchEvent(new CustomEvent(eventName, detail));
    }
};
